import { Component, Injector, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { EventBus, AppContext } from '@farris/devkit';
import { FrameworkSessionService } from '@farris/bef';
import { Declaration, Subscription } from '@farris/devkit';
import { RenderAppContextBuilder } from './common/context/render-app-context-builder';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'lib-farris-render-engine',
  template: `
    <lib-render-view
    [appContext]="appContext"
    [componentId]="'root-component'"
    [renderType]="'entire'">
    </lib-render-view>
  `,
  styles: [],
  providers: [
    EventBus,
    Declaration,
    Subscription,
    FrameworkSessionService
  ]
})
export class FarrisRenderEngineComponent implements OnInit, OnChanges {

  @Input() extendsFormMetadata = '';

  @Input() renderType: 'auto' | 'manual' = 'auto';

  @Input() formMetadataContent: any;

  public appContext: AppContext;

  private renderAppContextBuilder: RenderAppContextBuilder;

  constructor(
    private httpClient: HttpClient,
    private injector: Injector,
    private router: Router
  ) {
    this.renderAppContextBuilder = new RenderAppContextBuilder(this.httpClient, this.injector, this.router);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const metadataChanges = changes.formMetadataContent;
    if (metadataChanges && metadataChanges.previousValue !== metadataChanges.currentValue && this.renderType === 'manual') {
      this.renderAppContextBuilder.createByFormMetadataContent(this.formMetadataContent)
        .subscribe(appContext => this.appContext = appContext);
    }
  }

  ngOnInit() {
    if (this.renderType === 'auto') {
      this.renderAppContextBuilder.create()
        .subscribe(appContext => this.appContext = appContext);
    }
  }
}
